<template>
  <ol class="RunTimelineDateList">
    <li
      v-for="date in dates"
      :key="date.date.toISOString()"
      class="RunTimelineDateList__item"
      data-testid="runTimelineDate"
    >
      <h4
        class="RunTimelineDateList__itemHeader"
        data-testid="runTimelineDateHeader"
      >
        <span class="RunTimelineDateList__itemDate">{{ format(date.date, "M/d") }}</span>
        <span class="RunTimelineDateList__itemDay">{{ format(date.date, "EEE") }}</span>
      </h4>
      <RunTimelineRunList
        :runs="date.runs"
      />
    </li>
  </ol>
</template>

<script lang="ts" setup>
import { format } from "date-fns";
import { RunTimelineDate } from "./RunTimeline.types.ts";
import RunTimelineRunList from "./RunTimelineRunList.vue";

defineProps<{
  dates: Array<RunTimelineDate>,
}>();
</script>

<style lang="scss" scoped>
.RunTimelineDateList {
  display: grid;
  gap: 1px;
}

.RunTimelineDateList__item {
  display: grid;
  grid-template-columns: min-content auto;
  gap: 1px;

  outline: solid 1px var(--themeColorNeutral100);
}

.RunTimelineDateList__itemHeader {
  display: flex;
  flex-direction: column;
  gap: 10px;
  align-items: center;
  width: 64px;
  padding: 16px 0;

  outline: solid 1px var(--themeColorNeutral100);
}

.RunTimelineDateList__itemDate {
  font-size: 13px;
  font-stretch: var(--fontWidthExtended);
}

.RunTimelineDateList__itemDay {
  font-size: 24px;
  font-weight: var(--fontWeightMedium);
}
</style>
